import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
export var COUNTRYSIDE_BUILDER_FIELD = {
  field: {
    label: 'Наименование строительной компании',
    name: EFormFieldsNames.CountrysideBuilder,
    type: EExtendedFieldTypes.InputField,
    required: false
  },
  validation: yup.string()
};